import { createContext, useContext, useEffect, useState } from "react";

const ThemeCtx = createContext(null);

/**
 * Persists theme preference in localStorage and applies data-theme on <html>.
 * Also lets pages set a role tint via setRole('patient'|'clinician'|'admin'|null).
 */
export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    try {
      const saved = localStorage.getItem("fl_theme");
      if (saved === "light" || saved === "dark") return saved;
    } catch {}
    return "dark";
  });
  const [role, setRoleState] = useState(null);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    try { localStorage.setItem("fl_theme", theme); } catch {}
  }, [theme]);

  useEffect(() => {
    if (role) document.documentElement.setAttribute("data-role", role);
    else document.documentElement.removeAttribute("data-role");
  }, [role]);

  const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));
  const setRole = (r) => setRoleState(r || null);

  return (
    <ThemeCtx.Provider value={{ theme, setTheme, toggle, role, setRole }}>
      {children}
    </ThemeCtx.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeCtx) || { theme: "dark", toggle: () => {}, setRole: () => {} };
}
